var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.5 37.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6cd11c;}.cls-2,.cls-3{fill:#fff;}.cls-3{font-size:16px;font-family:MicrosoftSansSerif, Microsoft Sans Serif;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Starr_Logo",
    "data-name": "Starr Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,11.13,13.51,0l-.09,10.92-.1,10.92,2.57,0h.76v-2l-.76,0h0L16,6.4l6.16,6.86L28.3,20,22.57,20h-1v2l1,0h.59l10.34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.34,16H0L10.09,26.87l10.09,11V16.07Zm7.32,8.78v6.73l-6.22-6.81L5.22,18h6.37l6.07,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.57 19.94 21.57 21.95 16.65 21.89 16.65 19.88 21.57 19.94"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(45.42 23.86)"
  }, "Starr Light")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarrLogo);
export default __webpack_public_path__ + "static/media/Starr Logo.ba5b0d6c9e9161fea1687acc71825c0a.svg";
export { ForwardRef as ReactComponent };